/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import SponsorPlug from '@components/SponsorPlug';

const LockupSection = ({ text, logo }) => (
  <>
    {text && <p className="footer-heading pt-4">{text}</p>}
    {logo && (
      <div className="mb-4">
        {logo.map((logoItem, logoIndex) => (
          <SponsorPlug key={logoIndex} logo={logoItem} lockup />
        ))}
      </div>
    )}
  </>
);

export default LockupSection;
